import { render, staticRenderFns } from "./FormulateTreeselect.vue?vue&type=template&id=5f36ff46&"
import script from "./FormulateTreeselect.vue?vue&type=script&lang=js&"
export * from "./FormulateTreeselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports